import { render } from "./AddRolePage.vue?vue&type=template&id=bc018246&ts=true"
import script from "./AddRolePage.vue?vue&type=script&lang=ts"
export * from "./AddRolePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__